import React, { useState } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { ListBoxItem, ListBoxSection } from 'react-aria-components';

import { ComboBox } from 'wanderu-components';

import styles from './InputDropdown.scss';

const renderItem = ({ href, Icon, name }) => (
    <ListBoxItem
        className={styles.item}
        href={href}
        textValue={name}
    >
        {Icon && <Icon className={styles.itemIcon} />}
        {name}
    </ListBoxItem>
);

const renderSection = ({ attribution, children, id }) => (
    <>
        <ListBoxSection className={styles.section} id={id} items={children}>
            {renderItem}
        </ListBoxSection>
        {(attribution && children) && <ListBoxItem id={`${id}-attribution`} isDisabled>{attribution}</ListBoxItem>}
    </>
);

const InputDropdown = ({
    Icon,
    inputValue = '',
    items,
    name,
    onFocus,
    onInputChange,
    onSelectionChange,
    placeholder,
})=> {
    const [selectedKey, setSelectedKey] = useState(null);

    const handleSelectionChange = (id) => {
        if (!id) return;
        setSelectedKey(id);
        onSelectionChange(id);
    };

    const handleInputChange = (value) => {
        setSelectedKey(prevState => (value === '')
            ? null
            : prevState);

        onInputChange(value);
    };

    const handleFocus = (e) => {
        const value = e?.target?.value;

        if (value && !items) {
            onInputChange(value);
        }
        onFocus(e);
    };

    return (
        <ComboBox
            Icon={Icon}
            classes={{
                container: styles.container,
                inputContainer: classNames(styles.inputContainer, {
                    [styles.left]: name === 'origin',
                    [styles.right]: name === 'destination',
                }),
            }}
            inputValue={inputValue}
            items={items}
            name={name}
            onFocus={handleFocus}
            onInputChange={handleInputChange}
            onSelectionChange={handleSelectionChange}
            placeholder={placeholder}
            selectedKey={selectedKey}
        >
            {item => (item?.type === 'section')
                ? renderSection(item)
                : renderItem(item)
            }
        </ComboBox>
    );
};

InputDropdown.propTypes = {
    Icon: PropTypes.elementType,
    inputValue: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            name: PropTypes.string,
        })
    ),
    name: PropTypes.string,
    onFocus: PropTypes.func,
    onInputChange: PropTypes.func,
    onSelectionChange: PropTypes.func,
    placeholder: PropTypes.string,
};

export default InputDropdown;
